module.exports = __webpack_public_path__ + "img/customer-usecase-01.4e1d5b2d.jpg";